<template>
  <div class="layout-header">
    <div class="layout-title">
      {{ headerTitle }}
      <!-- <div class="layout-header-action bookmark-action">
        <c-button
          size="small"
          :icon="{
            icon: 'bookmark',
            activeColor: 'white',
          }"
          :tooltip="{
            text: 'Добавить в закладки',
            activeText: 'Убрать из закладок',
          }"
          active-color="blue"
          :active="bookmark"
          @click="bookmark = !bookmark"
        />
      </div> -->
    </div>
    <div class="layout-header-actions">
      <div class="layout-header-action">
        <c-button-2
          size="small"
          :label="createNewTypeLabel"
          :icon="{
            icon: 'plus',
            color: 'blue',
          }"
          @click="createNewTypeAction"
        />
      </div>
      <div class="layout-header-action">
        <c-button-2
          size="small"
          :label="createNewItemLabel"
          :icon="{
            icon: 'plus',
            color: 'blue',
          }"
          @click="createNewItemAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import button from "@/components/controls/button";

export default {
  name: "reference-header",
  components: {
    "c-button": Button,
    "c-button-2": button,
  },
  props: {
    headerTitle: {
      type: String,
      default: () => "",
    },
    createNewTypeLabel: {
      type: String,
      default: () => "",
    },
    createNewItemLabel: {
      type: String,
      default: () => "",
    },
    createNewTypeAction: {
      type: Function,
      default: () => {},
    },
    createNewItemAction: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      bookmark: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.layout-header {
  @media screen and (max-width: 639px) {
    flex-direction: column;
    margin-bottom: 4.8rem;
  }
}
.layout-title {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-right: 5px;
  align-items: center;
  @media screen and (max-width: 639px) {
    width: 100%;
    margin-bottom: 13px;
  }
}
.layout-header-actions {
  display: flex;
}
</style>
